module.exports = __webpack_public_path__ + "img/25-PROASA.e2f8a076.jpg";